import React from "react";
import {connect} from "react-redux";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import Browser from "../Browser/Browser";
import Logo from "../Picto/Logo";
import {Image, TouchableOpacity, ActivityIndicator, Linking, StyleSheet, Text, View } from "react-native";
import AvatarIcon from "../Header/AvatarIcon";
import {checkIFramable} from "../../API/API";


// this.props: text, onPress, style, bg_color, color
class Button extends React.Component {
    render() {
        const backgroundColor = this.props.bg_color || this.props.theme.colors.primary.blue1.value;
        const color = this.props.color || "#fff";

        const styles = StyleSheet.create({
           button : {
              borderRadius: 10,
              backgroundColor: backgroundColor,
              paddingVertical: 10,
              paddingHorizontal: 15,
            },
            text:{
               color: color,
               fontFamily: this.props.theme.fonts.text
            }
        });
        return (<TouchableOpacity onPress={this.props.onPress}>
          <View style={[styles.button, this.props.style]}>
            <Text style={styles.text}>{ this.props.text }</Text>
          </View>
        </TouchableOpacity>);
    }
}


class WebviewScreen extends React.Component {
    constructor(props) {
        super(props);
        this._setHeaderLogoCompte = this._setHeaderLogoCompte.bind(this);

        this.state = { pending: true, status: null };

        const url = props.route.params.url

        checkIFramable(url).then(x => {
          this.setState({ pending: false, status: x.status })
        }).catch(() => this.setState({ pending: false }))

        this.back = this.back.bind(this);
        this.openURL = this.openURL.bind(this);
    }

    componentDidMount() {
        this._setHeaderLogoCompte();
    }

    _setHeaderLogoCompte(){
        const styleHeaderGlobal = {
            shadowOpacity: 0,
            shadowRadius: 0,
            borderWidth:0,
            elevation: 0,
            borderColor:"transparent" ,
            borderBottomWidth:0,
            backgroundColor : this.props.theme.colors.tertiary.grey3.value,
            height:60
        }  ;

        this.props.navigation.setOptions({
            headerRight : ()=>{},
            headerTitle: () => (<Logo />),
            headerStyle: styleHeaderGlobal,
            headerTitleAlign: "center",
            cardStyle: { backgroundColor: this.props.theme.colors.tertiary.grey3.value},
            headerLeft : ()=><TouchableOpacity onPress={this.props.navigation.goBack}>
                <Image resizeMode={"contain"} style={{width:20,marginLeft:10,height: 20, flex: 1}} source={this.props.theme.pictos.chevronGaucheMediumPicto.light} />
            </TouchableOpacity>
            , });
    }

    openURL() {
      setTimeout(() => { this.props.navigation.goBack(); }, 0);
      Linking.openURL(this.props.route.params.url);
    }

    back() {
      this.props.navigation.goBack();
    }

    render(){
      const { pending, status } = this.state;
      const { t, theme, route } = this.props;

      const styles = StyleSheet.create({
        container: { flex: 1, justifyContent: "center"},
        textWrapper: {
          flex: 1,
          flexDirection: "column",
          justifyContent: "center",
          paddingHorizontal: 40,
        },
        text: {
          color: theme.colors.tertiary.black1.value
        },
        buttons: {
            flex: 1,
            flexDirection: "row",
            justifyContent: "space-around",
            paddingHorizontal: 40,
            marginTop: 20
        }
      });

      if (pending) {

        return <View style={styles.container}>
          <ActivityIndicator size="large" color={theme.colors.primary.blue1.value} />
        </View>
      }

      if (status === 'unprotected') {
        return <Browser url={route.params.url}/>
      } else {
        return <View style={styles.container}>
        <View>
          <View style={styles.textWrapper}>
            <Text style={styles.text}>
              {t(
                "The website does not authorize the display of its content from within a third-party application. Open in your browser?"
              )}
            </Text>
          </View>
          <View style={styles.buttons}>
              <Button text={t("No")} onPress={this.back} theme={this.props.theme}
                      color="#fff"
                      bg_color={theme.colors.secondary.orange1.value} />
              <Button text={t("Yes")} onPress={this.openURL} theme={this.props.theme}
                      color="#fff"
                      bg_color={theme.colors.primary.blue1.value} />
          </View>
        </View>
        </View>
      }

    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(withTranslation(),connect(mapStateToProps))(WebviewScreen);
